import { get } from './request';
import { FormatDateYMD } from './date';
import { get as getIzee } from './api-izee';

export const getDataByDocument = async (document: string): Promise<any> => {
  return document.length <= 11 ? getDataByCPF(document) : getDataByCNPJ(document);
};

const getDataByCPF = async (cpf: string) => {
  const response = await get(`/documents/${cpf}`);
  return response;
};

const getDataByCNPJ = async (cnpj: string) => {
  return await get(`/documents/${cnpj}`);
};

export const getCompanyIzee = async (value: string) => {
  if (value === undefined || value === '') return [];
  return await getIzee(`/company/search?q=${value}`);
};

export const getDocumentIzee = async (company: number, value: string) => {
  return await getIzee(`/company/${company}/client/search?q=${value}`);
};

export const getClientIzee = async (company: number, id: number) => {
  return await getIzee(`/company/${company}/client/${id}`);
};
